import { throPtErr } from './sharedErrF.mts';
import { jsonReplacerBigintSafeF } from './serErrDebugAI.mts';
// context is a debugH object, not a string message; it rides IN the message too — the bare
// condition body (e.g. "!value" for every assertTruthy failure) is undiagnosable on surfaces
// that only show err.message (phone refused lines, node console)
export const throwIf = (conditionFn, context) => {
    const result = conditionFn();
    if (result) {
        const fnString = conditionFn.toString();
        const expression = fnString.substring(fnString.indexOf('=>') + 2).trim();
        throPtErr(context && Object.keys(context).length ? `${expression} ${JSON.stringify(context, jsonReplacerBigintSafeF)}` : expression, context);
    }
};
